import { cn } from 'cn';

import type { StatusRegistro } from '@shared/dto';

import { STATUS_EMOJI } from '../../../lib/registro-emojis';
import { STATUS_REGISTRO_LABEL } from './enum-labels';

const CLASSES: Record<StatusRegistro, string> = {
  NAO_INICIADO: 'bg-slate-100 text-slate-600 border-slate-200',
  PENDENTE: 'bg-orange-50 text-orange-700 border-orange-200',
  CONCLUIDO: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export function StatusRegistroBadge({ status }: { status: StatusRegistro }) {
  return (
    <span className={cn('rounded-full border px-2.5 py-1 text-xs font-medium', CLASSES[status])}>
      {STATUS_EMOJI[status]} {STATUS_REGISTRO_LABEL[status]}
    </span>
  );
}
